import { useContext } from 'react';
import { zIndexContext } from './context';

export const useZIndex = () => {
  const zIndex = useContext(zIndexContext);
  return zIndex;
};
